<template>
  <a
    class="row file"
    target="_blank"
    :href="file.downloadUrl">
    <div class="col-12 col-md-10 d-flex align-items-center p-0">
      <div class="file__image">
        <img src="../../assets/images/gray-ratio3x2.png" :alt="file.title" v-if="!file.iconUrl" />
        <img :src="`${baseUrl}${file.iconUrl}`" :alt="file.title" v-if="file.iconUrl" />
      </div>
      <div class="file__data">
        <div class="file__title">{{ file.title }}</div>
        <div class="file__description">{{ file.description }}</div>
        <div class="d-md-none">
          <span class="file__meta__kind mr-1">{{ file.contentType }}</span>
          <span class="file__meta__size mr-1">{{ file.fileType }} ({{ file.fileSize }})</span>
          <span class="file__meta__date">{{ file.lastUpdated.date |  moment("MMM DD, YYYY") }}</span>
        </div>
      </div>
    </div>
    <div class="col-2 d-md-flex d-none flex-column justify-content-center align-items-start file__meta">
      <div class="file__meta__kind">{{ file.contentType }}</div>
      <div class="file__meta__size">{{ file.fileType }} ({{ file.fileSize }})</div>
      <div class="file__meta__date">{{ file.lastUpdated.date |  moment("MMM DD, YYYY") }}</div>
    </div>
  </a>
</template>

<script>
  import config from "../../config";
  export default {
    name: "UXFolderFileDocument",
    data() {
      return {
        baseUrl: config.baseUrl
      }
    },
    props: {
      file: Object
    }
  };
</script>
